import { BankAccountsActionType } from './actions';
import { handleErrorInfo } from '../../utils';
import { BankAccountsState, Banks } from './interfaces';

const initialState: BankAccountsState = {
  loading: true,
  error: false,
  errorInfo: undefined,
  allBankAccounts: undefined,
  newBankAccount: {
    loading: false,
    error: false,
    errorInfo: undefined,
    banks: {},
    show: false,
    success: false,
  },
  editBankAccount: {
    loading: false,
    error: false,
    errorInfo: undefined,
    success: undefined,
  },
};

const BankAccounts = (state = initialState, action: any) => {
  switch (action.type) {
    case BankAccountsActionType.GET_BANK_ACCOUNTS: {
      return {
        ...state,
        loading: true,
        error: false,
        errorInfo: null,
      };
    }
    case BankAccountsActionType.GET_BANK_ACCOUNTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        allBankAccounts: {
          data: action.response,
        },
      };
    }
    case BankAccountsActionType.GET_BANK_ACCOUNTS_ERROR: {
      return {
        ...state,
        loading: false,
        error: true,
        errorInfo: handleErrorInfo(BankAccountsActionType.GET_BANK_ACCOUNTS_ERROR, action.error),
        allBankAccounts: null,
      };
    }
    case BankAccountsActionType.SHOW_NEW_BANK_ACCOUNT: {
      return {
        ...state,
        newBankAccount: {
          ...state.newBankAccount,
          error: false,
          errorInfo: undefined,
          show: action.show,
        },
      };
    }
    case BankAccountsActionType.GET_BANKS_FOR_BANK_ACCOUNTS: {
      return {
        ...state,
        newBankAccount: {
          ...state.newBankAccount,
          loading: true,
          error: false,
          errorInfo: undefined,
          success: false,
        },
      };
    }
    case BankAccountsActionType.GET_BANKS_FOR_BANK_ACCOUNTS_SUCCESS: {
      const banks: Banks = {};
      action.response.forEach((b: { code: string; name: string }) => {
        banks[`BANK_CODE_${b.code}`] = b.name;
      });
      return {
        ...state,
        newBankAccount: {
          ...state.newBankAccount,
          loading: false,
          error: false,
          errorInfo: undefined,
          banks,
          success: false,
        },
      };
    }
    case BankAccountsActionType.GET_BANKS_FOR_BANK_ACCOUNTS_ERROR: {
      return {
        ...state,
        newBankAccount: {
          ...state.newBankAccount,
          loading: false,
          error: true,
          errorInfo: handleErrorInfo(BankAccountsActionType.GET_BANKS_FOR_BANK_ACCOUNTS_ERROR, action.error),
          banks: {},
        },
      };
    }
    case BankAccountsActionType.ADD_BANK_ACCOUNT: {
      return {
        ...state,
        newBankAccount: {
          ...state.newBankAccount,
          loading: true,
          error: false,
          errorInfo: undefined,
          success: false,
        },
      };
    }
    case BankAccountsActionType.ADD_BANK_ACCOUNT_SUCCESS: {
      return {
        ...state,
        newBankAccount: {
          ...state.newBankAccount,
          loading: false,
          error: false,
          errorInfo: undefined,
          success: true,
          show: false,
        },
      };
    }
    case BankAccountsActionType.ADD_BANK_ACCOUNT_ERROR: {
      return {
        ...state,
        newBankAccount: {
          ...state.newBankAccount,
          loading: false,
          error: true,
          errorInfo: handleErrorInfo(BankAccountsActionType.ADD_BANK_ACCOUNT_ERROR, action.error),
        },
      };
    }
    case BankAccountsActionType.EDIT_BANK_ACCOUNT: {
      return {
        ...state,
        editBankAccount: {
          ...state.editBankAccount,
          loading: true,
          error: false,
          errorInfo: undefined,
        },
      };
    }
    case BankAccountsActionType.EDIT_BANK_ACCOUNT_SUCCESS: {
      const baEdited = action.response;
      const data = state.allBankAccounts?.data?.map(ba => (ba.id === baEdited.id ? baEdited : ba)) || null;
      return {
        ...state,
        allBankAccounts: {
          data,
        },
        editBankAccount: {
          ...state.editBankAccount,
          loading: false,
          error: false,
          errorInfo: undefined,
          success: baEdited,
        },
      };
    }
    case BankAccountsActionType.EDIT_BANK_ACCOUNT_ERROR: {
      return {
        ...state,
        editBankAccount: {
          ...state.editBankAccount,
          loading: false,
          error: true,
          errorInfo: handleErrorInfo(BankAccountsActionType.EDIT_BANK_ACCOUNT_ERROR, action.error),
        },
      };
    }
    default:
      return state;
  }
};

export default BankAccounts;
